import { IClassName } from '../../../utils';
import { SvgIconOption } from '../SvgIcon/types';

export enum AlertStatus {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export interface IAlert extends IClassName {
  title: string;
  message?: string;
  iconName?: SvgIconOption;
  closeIconName?: SvgIconOption;
  status?: AlertStatus;
  hasClose?: boolean;
  onClose?: () => void;
}

export default IAlert;
